import React from 'react';

import { cn } from '@/utils/cn';

import ErrorIcon from '../../assets/icons/error.svg';
import Spinner from '../atoms/Spinner';

interface ViewDataWrapperProps {
	children: React.ReactNode;
	isLoading: boolean;
	isError: boolean;
	className?: string;
	noWrapper?: boolean;
}

const ViewDataWrapper: React.FC<ViewDataWrapperProps> = (props) => {
	if (props.noWrapper && !props.isLoading && !props.isError) {
		return <>{props.children}</>;
	}
	return (
		<div className={cn('h-[85vh] w-[92vw]', props.className ?? '')}>
			{props.isLoading ? (
				<div className="my-4 flex h-[100%] w-full items-center rounded-md bg-white">
					<Spinner size={40} />
				</div>
			) : props.isError ? (
				<div className="w-full px-[1%]">
					<div className="flex h-[100%] w-full flex-col items-center justify-center rounded-md bg-white">
						<img
							src={ErrorIcon}
							className="w-24"
							alt="Erro ao carregar os dados"
						/>
						<div className="flex flex-col items-center text-center">
							Não foi possível carregar os dados
							<span className="font-semibold text-blue-800">
								tente novamente mais tarde!
							</span>
						</div>
					</div>
				</div>
			) : (
				<div className="my-4 flex h-[90vh] w-full flex-col gap-4">
					{props.children}
				</div>
			)}
		</div>
	);
};

export default ViewDataWrapper;
